export let HyperParam = {
  hyperParamId: '',
  value: null
}

export let HyperParamSummary = {
  hyperParamId: '',
  hyperParamName: '',
  defaultVal: '' | 0,
  description: {
    text: ''
  }
}

export const HYPER_PARAM_SETTINGS = {
  regularize: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'L1', value: 'l1'
      }, {
        label: 'L2', value: 'l2'
      }]
  },
  penalty: {
    type: 'input',
    validate: 'required|decimal:*|between:0,10000'
  },
  seed: {
    type: 'input',
    validate: 'integer|between:0,1000'
  },
  dt_criterion: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'gini', value: 'gini'
      }, {
        label: 'entropy', value: 'entropy'
      }]
  },
  features_split: {
    type: 'switch-input',
    validate: 'integer|min_value:1',
    inactiveLabel: '指定なし',
    activeLabel: '項目数指定',
    extraOptions: [
      {
        label: 'auto', value: 'auto'
      }, {
        label: 'sqrt', value: 'sqrt'
      }, {
        label: 'log2', value: 'log2'
      }]
  },
  depth: {
    type: 'input',
    validate: 'required|integer|min_value:1'
  },
  leaf_samples: {
    type: 'input',
    validate: 'required|integer|min_value:1'
  },
  kn_neighbors: {
    type: 'input',
    validate: 'required|integer|between:1,30'
  },
  kn_algorithm: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'auto', value: 'auto'
      }, {
        label: 'ball_tree', value: 'ball_tree'
      }, {
        label: 'kd_tree', value: 'kd_tree'
      }]
  },
  kn_leaf_size: {
    type: 'input',
    validate: 'required|integer|between:1,10000'
  },
  kernel: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Linear', value: 'linear'
      }, {
        label: 'Poly', value: 'poly'
      }, {
        label: 'RBF', value: 'rbf'
      }, {
        label: 'Sigmoid', value: 'sigmoid'
      }]
  },
  sv_degree: {
    type: 'input',
    validate: 'required|integer|between:1,100'
  },
  sv_gamma: {
    type: 'input',
    validate: 'required|decimal:*|between:0,10'
  },
  max_iter: {
    type: 'input',
    validate: 'integer|between:1,10000',
    inactiveLabel: '指定なし',
    activeLabel: '反復数指定'
  },
  smooth: {
    type: 'input',
    validate: 'required|decimal:*|between:0,10'
  },
  estimators: {
    type: 'input',
    validate: 'required|integer|between:1,1000'
  },
  learning_rate: {
    type: 'input',
    validate: 'required|decimal:*|between:0,10'
  },
  boosting_type: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'GBDT', value: 'gbdt'
      }, {
        label: 'DART', value: 'dart'
      }]
  },
  num_leaves: {
    type: 'input',
    validate: 'required|integer|between:2,1000'
  },
  alpha: {
    type: 'input',
    validate: 'required|decimal:*|between:0,3'
  },
  lambda: {
    type: 'input',
    validate: 'required|decimal:*|between:0,3'
  },
  fit_intercept: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  l1_ratio: {
    type: 'input',
    validate: 'required|decimal:*|between:0,1'
  },
  n_units_1: {
    type: 'n_units',
    validate: 'integer|between:0,10000'
  },
  batch_size: {
    type: 'input',
    validate: 'integer|between:2,10000000'
  },
  epoch: {
    type: 'input',
    validate: 'integer|between:1,100'
  },
  drop_ratio: {
    type: 'input',
    validate: 'required|decimal:*|between:0,1'
  },
  optimizer: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Adam', value: 'adam'
      }, {
        label: 'AdaGrad', value: 'adagrad'
      }, {
        label: 'SGD', value: 'sgd'
      }, {
        label: 'Momentum', value: 'momentum'
      }]
  },
  m_alpha: {
    type: 'input',
    validate: 'required|decimal:*|between:0,10'
  },
  beta_1: {
    type: 'input',
    validate: 'required|decimal:*|between:0,10'
  },
  beta_2: {
    type: 'input',
    validate: 'required|decimal:*|between:0,10'
  },
  filling: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Auto', value: 'Auto'
      }, {
        label: 'Zero', value: 'Zero'
      }, {
        label: 'Average', value: 'Average'
      }, {
        label: 'Median', value: 'Median'
      }]
  },
  create_na: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  ignore_too_many: {
    type: 'switch-input',
    validate: 'integer|min_value:1',
    inactiveLabel: '指定なし',
    activeLabel: '上限指定',
    extraOptions: []
  },
  return_distance: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'なし', value: '0'
      }, {
        label: 'あり', value: '1'
      }]
  },
  clusters: {
    type: 'input',
    validate: 'required|integer|between:2,20'
  },
  try_count: {
    type: 'input',
    validate: 'required|integer|between:1,10'
  },
  to_be_dummy: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'しない', value: '0'
      }, {
        label: 'する', value: '1'
      }]
  },
  components: {
    type: 'switch-input',
    validate: 'integer|min_value:1',
    inactiveLabel: '指定なし',
    activeLabel: '上限指定'
  },
  whiten: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: '行わない', value: '0'
      }, {
        label: '行う', value: '1'
      }]
  },
  contribution_threshold: {
    type: 'input',
    validate: 'required|decimal:*|between:0,1'
  },
  iterations: {
    type: 'input',
    validate: 'integer|min_value:1'
  },
  main_pos: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: '限定する', value: '1'
      }, {
        label: '限定しない', value: '0'
      }]
  },
  max_words_count: {
    type: 'switch-input',
    validate: 'integer|between:1,10000',
    inactiveLabel: '指定なし',
    activeLabel: '上限指定'
  },
  stop_words: {
    type: 'stop-words',
    validate: ''
  },
  delta: {
    type: 'input',
    validate: 'required|decimal:*|between:0.0001,1'
  },
  outlier_limit: {
    type: 'input',
    validate: 'required|integer|min_value:1'
  },
  upper_limit: {
    type: 'input',
    validate: 'required|integer|between:1,100'
  },
  lower_limit: {
    type: 'input',
    validate: 'required|integer|between:2,100'
  },
  offset: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Auto', value: 'Auto'
      }, {
        label: 'LimitValue', value: 'LimitValue'
      }, {
        label: 'KeepOrder', value: 'KeepOrder'
      }, {
        label: 'KeepGap', value: 'KeepGap'
      }]
  },
  return_input: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: '結果のみ', value: '0'
      }, {
        label: '元のデータと結果の両方', value: '1'
      }]
  },
  growth: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Linear', value: 'linear'
      }, {
        label: 'Logistic', value: 'Logistic'
      }]
  },
  cap: {
    type: 'input',
    validate: 'decimal:*'
  },
  floor: {
    type: 'input',
    validate: 'decimal:*'
  },
  yearly_seasonality: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: '自動', value: 'auto'
      }, {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  weekly_seasonality: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: '自動', value: 'auto'
      }, {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  daily_seasonality: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: '自動', value: 'auto'
      }, {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  seasonality_mode: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Additive', value: 'additive'
      }, {
        label: 'Multiplicative', value: 'multiplicative'
      }]
  },
  seasonality_prior_scale: {
    type: 'input',
    validate: 'decimal:*|min_value:1'
  },
  mcmc_samples: {
    type: 'input',
    validate: 'integer|min_value:0'
  },
  interval_width: {
    type: 'input',
    validate: 'decimal:*|between:0,1'
  },
  uncertainty_samples: {
    type: 'input',
    validate: 'integer|min_value:1'
  },
  log_std_threshold: {
    type: 'input',
    validate: 'required|integer|min_value:1'
  },
  evaluator: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'AUC', value: 'AUC'
      }, {
        label: 'CORR', value: 'CORR'
      }],
    readonly: true
  },
  upper: {
    type: 'input-target',
    // validate: "required|decimal:*|between:0,1",
    validate: {
      required: true,
      decimal: '*',
      between: [0, 1],
      more_than: ['下限値']
    },
    targetValidateMethod: 'more_than',
    target: 'lower'
  },
  lower: {
    type: 'input-target',
    // validate: "required|decimal:*|between:0,1",
    validate: {
      required: true,
      decimal: '*',
      between: [0, 1],
      less_than: ['上限値']
    },
    targetValidateMethod: 'less_than',
    target: 'upper'
  },
  prop_of_outlier: {
    type: 'input',
    validate: 'required|decimal:*|between:0.0001,1'
  },
  create_abs: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  add_freq: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  create_row_freq: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  frequency_limit: {
    type: 'input',
    validate: 'required|decimal:*|between:0,1'
  },
  ignore_too_few: {
    type: 'input',
    validate: 'required|integer|min_value:1'
  },
  max_remains_count: {
    type: 'input',
    validate: 'required|integer|min_value:1'
  },
  day_of_week: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  weekend: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  holiday: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  weekend_or_holiday: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'あり', value: '1'
      }, {
        label: 'なし', value: '0'
      }]
  },
  corr_threshold: {
    type: 'input',
    validate: 'required|decimal:*|between:0,1'
  },
  neighbors: {
    type: 'input',
    validate: 'required|integer|between:1,100'
  },
  n_trees: {
    type: 'input',
    validate: 'required|integer|between:1,1000'
  },
  search_k: {
    type: 'switch-input',
    validate: 'integer|between:1,10000',
    inactiveLabel: '指定なし',
    activeLabel: '探索回数数指定'
  },
  metric: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Auto', value: 'Auto'
      }, {
        label: 'Euclidean', value: 'Euclidean'
      }, {
        label: 'Manhattan', value: 'Manhattan'
      }]
  },
  n_features_limit: {
    type: 'input',
    validate: 'required|integer|between:1,10'
  },
  gp_generation: {
    type: 'input',
    validate: 'required|integer|between:1,10'
  },
  gp_population: {
    type: 'input',
    validate: 'required|integer|between:1,200'
  },
  gp_tournament_size: {
    type: 'input',
    validate: 'required|integer|between:1,10'
  },
  gp_crossover_rate: {
    type: 'input',
    validate: 'required|decimal:*|between:0,1'
  },
  gp_mutation_rate: {
    type: 'input',
    validate: 'required|decimal:*|between:0,1'
  },
  smoothing_method: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: 'Auto', value: 'Auto'
      }, {
        label: 'Binomial', value: 'Binom'
      }, {
        label: 'Sigmoid', value: 'Sigmoid'
      }]
  },
  text_transformer: {
    type: 'radio-group',
    validate: '',
    options: [
      {
        label: '意味内容の数値化（Text2Vec）', value: 'Text2Vec'
      }, {
        label: '重要単語分析（TFIDF）', value: 'TFIDF'
      }]
  }
}



// WEBPACK FOOTER //
// ./src/defines/hyper-param.js